module.exports = __webpack_public_path__ + "static/media/Universitas Multimedia Nusantara.9e494b70.jpg";